/**
 * Compares two objects.
 *
 * If any object is undefined, then the comparison fails.
 */
function compareShallowObject(cur, prev) {
    if (!cur || typeof cur !== 'object')
        return false;
    if (!prev || typeof prev !== 'object')
        return false;
    if (cur === prev)
        return true;
    const keys1 = Object.keys(cur);
    const keys2 = Object.keys(prev);
    const keyset2 = new Set(keys2);
    return (keys1.length === keys2.length &&
        keys1.every((k) => keyset2.has(k) && cur[k] === prev[k]));
}
/**
 * Compares 2D vectors.
 */
function compareVector2(cur, prev) {
    if (cur === prev)
        return true;
    if (!cur || !prev)
        return false;
    return cur[0] === prev[0] && cur[1] === prev[1];
}

export { compareShallowObject, compareVector2 };
